import React, { Component } from "react";
import SortProvider from "../../Section/Homepage/sort";
import "./index.css";
import backimage from "../../../asset/topbar.png";
import Panel from "./Panel";
import Rates from "../../Section/Homepage/rate";

class Homepage extends Component {
  render() {
    return (
      <Panel
        title="Afrex"
        detail={`Find the best currency exchange
          rate for you.`}
        backimage={backimage}
      >
        <SortProvider />
        <Rates />
        <Rates />
      </Panel>
    );
  }
}

export default Homepage;
